"use client";

import { useEffect, useState } from "react";
import Calendar from "./calendar";
import { Mode } from "@/components/calendar/calendar-types";
import {
  CalendarLocation,
  CalendarPartner,
  CalendarVehicle,
  CalendarEvent,
  ReservationState,
} from "./calendar-types";
import { getReservationStates } from "./reservation-service";
import { useGetList } from "react-admin";
import { Reservation } from "@/interface/entityInterface";
import { useUserContext } from "@/context/UserContext";

export default function ReservationsCalendar() {
  const {decodedToken} = useUserContext()
  const { data = [] } = useGetList("auto-service-reservation");
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [mode, setMode] = useState<Mode>("month");
  const [date, setDate] = useState<Date>(new Date());
  const [locations, setLocations] = useState<CalendarLocation[]>([]);
  const [partners, setPartners] = useState<CalendarPartner[]>([]);
  const [vehicles, setVehicles] = useState<CalendarVehicle[]>([]);
  const [reservationStates, setReservationStates] = useState<
    ReservationState[]
  >(getReservationStates());

  useEffect(() => {
    if (data.length == 0) return;
    const unsub = async () => {
      if (!decodedToken || !decodedToken?.user?.id) return;
      let events: CalendarEvent[] = [];

      events = data.map((reservation: Reservation) => ({
        ...reservation,
        id: "" + reservation.id,
        title: `${reservation?.guest_user?.name} - ${reservation?.guest_vehicle?.license_plate}`,
        start: new Date(reservation.date),
        end: new Date(reservation.date),
        color: "black",
      }));

      setEvents(events);
    };
    
    unsub();
  }, [data]);

  return (
    <Calendar
      events={events}
      setEvents={setEvents}
      mode={mode}
      setMode={setMode}
      date={date}
      setDate={setDate}
      vehicles={vehicles}
      setVehicles={setVehicles}
      locations={locations}
      setLocations={setLocations}
      partners={partners}
      setPartners={setPartners}
      reservationStates={reservationStates}
      setReservationStates={setReservationStates}
    />
  );
}
